import { useLastPathSegment } from 'shared/hooks'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'

export const useRcsProgressTitle = () => {
  const { navigationStore } = useRcsWizardContext()

  return navigationStore.getProgressInfoTitle(navigationStore.getStepFromPath(useLastPathSegment()))
}
